import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export function renderRichText(doc, options) {
  if (!doc) return null;
  return documentToReactComponents(doc, options || {});
}
